import type {ReactElement} from 'react';
import {ClickableDiv} from '@Components/clickable-div';
import styles from './ai-chat-assets-grid-tile.module.scss';
import type {AiChatAssetsGridTileProps} from './ai-chat-assets-grid-tile.types';
import {AiChatGeneratedAssetType} from '@AiChat/ai-chat.types';
import {AiChatAssetsVideoTile} from '../ai-chat-assets-video-tile/ai-chat-assets-video-tile';
import {AiChatAssetsImageTile} from '../ai-chat-assets-image-tile/ai-chat-assets-image-tile';

export function AiChatAssetsGridTile({asset, onClick}: AiChatAssetsGridTileProps): ReactElement {
  const getTileContent = (): ReactElement => {
    if (asset.type === AiChatGeneratedAssetType.VIDEO) {
      return <AiChatAssetsVideoTile asset={asset} />;
    }

    return <AiChatAssetsImageTile asset={asset} />;
  };

  return (
    <ClickableDiv className={styles.tile} onClick={onClick}>
      {getTileContent()}
    </ClickableDiv>
  );
}
